import React, { useState } from "react";

import SelectInput from "../../../../components/formElements/selectInput/SelectInput";
import TextInput from "../../../../components/formElements/input/TextInput";
import RadioButton from "../../../../components/formElements/radio-button/RadioButton";
import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";
import Card from "../../../../layout/Onboarding/Card";
import constants from "../../../../constants";

export const PersonalDetailsCard = ({
  personalPatientInfo,
  setPatientPersonalInfo,
  form,
}) => {
  const heightStyles = {
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };
  const [heightChange, setOnChange] = useState(true);
  return (
    <Card>
      <div className="mb-n4">
        <TextInput
          id="firstName"
          error={form.firstName}
          maxLength={15}
          type="text"
          label="First Name"
          value={personalPatientInfo.firstName}
          onChange={val => setPatientPersonalInfo({ firstName: val })}
        />
        <TextInput
          id="lastName"
          error={form.lastName}
          maxLength={15}
          type="text"
          label="Last Name"
          value={personalPatientInfo.lastName}
          onChange={val => setPatientPersonalInfo({ lastName: val })}
        />
      </div>
      <div className="mt-n5 ml-n2 d-inline">
        <RadioButton
          containerClassName="d-inline"
          label="Male"
          value="MALE"
          name="gender"
          checked={personalPatientInfo.gender === "MALE"}
          onChange={val => setPatientPersonalInfo({ gender: val })}
        />
        <RadioButton
          containerClassName=" d-inline"
          label="Female"
          value="FEMALE"
          name="gender"
          checked={personalPatientInfo.gender === "FEMALE"}
          onChange={val => setPatientPersonalInfo({ gender: val })}
        />
      </div>
      <div className="mt-5 mb-4">
        {personalPatientInfo.height && heightChange ? (
          <div>
            <TextInput
              id="height"
              maxLength={15}
              type="text"
              label="height"
              value={personalPatientInfo.height}
              onChange={val => setOnChange(false)}
            />
          </div>
        ) : (
          <div className="mt-n4 mb-5 d-flex flex-row ">
            <div className="w-50 mr-1">
              <SelectInput
                error={form.current_feets}
                options={constants.FEETS}
                label="Height in feet"
                placeholder="Height in feet"
                styles={heightStyles}
                value={personalPatientInfo.current_feets}
                onChange={val =>
                  setPatientPersonalInfo({
                    current_feets: val,
                    current_height: val.value * 12,
                  })
                }
              />
            </div>
            <div className="w-50 ml-1">
              <SelectInput
                isCreateble={true}
                error={form.current_inches}
                options={constants.INCHES}
                label="Height in inches"
                placeholder="Height in inches"
                styles={heightStyles}
                value={personalPatientInfo.current_inches}
                onChange={val =>
                  setPatientPersonalInfo({
                    current_inches: val,
                    current_height:
                      personalPatientInfo.current_feets.value * 12 + val.value,
                  })
                }
              />
            </div>
          </div>
        )}
        <TextInput
          id="weight"
          error={form.weight}
          maxLength={15}
          type="number"
          label="Weight(lbs)"
          value={personalPatientInfo.weight}
          onChange={val => setPatientPersonalInfo({ weight: val })}
        />
        <TextInput
          id="bmi"
          error={form.bmi}
          maxLength={15}
          type="text"
          label="BMI"
          value={
            (personalPatientInfo.bmi =
              personalPatientInfo.weight && personalPatientInfo.current_height
                ? (
                    (personalPatientInfo.weight * 703) /
                    (personalPatientInfo.current_height *
                      personalPatientInfo.current_height)
                  ).toFixed(2)
                : personalPatientInfo.bmi)
          }
        />
      </div>
      <div className="mt-n4 mb-5" style={{ marginTop: "-20px" }}>
        <DateTimePicker
          mode="date"
          type="personalPatientInfo"
          placeholder="Date of Birth"
          value={personalPatientInfo.date_of_birth}
          customInput={true}
          onChange={val => setPatientPersonalInfo({ date_of_birth: val })}
        />
      </div>
    </Card>
  );
};
